import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-form-input-app',
  templateUrl: './form-input-app.component.html',
  styleUrls: ['./form-input-app.component.scss']
})
export class FormInputAppComponent implements OnInit {
  @Input() isRequired: boolean = false;
  @Input() labelText: string = '';
  @Input() margin0Input: boolean = false;
  @Input() margin0BottomInput: boolean = false;
  @Input() length: number;

  constructor() { }

  ngOnInit(): void {
  }

  getLabelClass() {
    return {
      'azul-a3Factura mb-0': true,
      ['col-md-' + (this.length || 14)]: true,
      'p-0': !!this.length
    };
  }

  getDivClass() {
    return {
      ['col-md-' + (this.length || 14)]: true,
      'p-0': !!this.length
    };
  }
}
